// Jest Snapshot v1, https://goo.gl/fbAQLP

exports[`StepCounter test Match con el snapshot 1`] = `""`;
